module.exports = __webpack_public_path__ + "static/img/hsfbanner1.75a1bd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hsfbanner1.jpg
// module id = hw+m
// module chunks = 5